import { ExportState } from "./types";
import { ExportFilters } from "@/models/export/filters";

export const setExportFilters = (state: ExportState, value: ExportFilters) => {
  state.exportFilters = value;
};
